module.exports = __webpack_public_path__ + "img/align-right.caaa1ac3.svg";